import { alpha } from '@mui/material';

import type { Theme } from '../../themes/themes';

export const createTooltipTheme = (theme: Theme): Partial<Theme> => ({
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: theme.palette.background.default,
          boxShadow: `0px 1px 4px 0.5px ${alpha(theme.palette.grey[800], 0.4)}`,
          borderRadius: 2 * theme.shape.borderRadius,
          color: theme.palette.text.secondary,
          ...theme.typography.button,
          padding: theme.spacing(5),
        },
        arrow: {
          color: theme.palette.background.default,
        },
      },
      defaultProps: {},
    },
  },
});
